<template>
  <div>
    <!-- Payment Statistics -->
    <div class="overview-line">
      <div class="md-layout md-gutter">
        <div
          class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-size-25"
        >
          <box
            :box-color="'green'"
            :center-text="true"
            :header-text="'Total Transactions'"
            :sub-text="stats.totalTransactions.toString()"
            :box-icon="'payment'"
          />
        </div>
        <div
          class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-size-25"
        >
          <box
            :box-color="'blue'"
            :center-text="true"
            :header-text="'Successful Payments'"
            :sub-text="stats.successfulTransactions.toString()"
            :box-icon="'check_circle'"
          />
        </div>
        <div
          class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-size-25"
        >
          <box
            :box-color="'orange'"
            :center-text="true"
            :header-text="'Pending Payments'"
            :sub-text="stats.pendingTransactions.toString()"
            :box-icon="'schedule'"
          />
        </div>
        <div
          class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-size-25"
        >
          <box
            :box-color="credentialStatus.color"
            :center-text="true"
            :header-text="'Configuration'"
            :sub-text="credentialStatus.text"
            :box-icon="'settings'"
          />
        </div>
      </div>
    </div>

    <!-- Configuration Section -->
    <div class="overview-line">
      <div class="md-layout md-gutter">
        <div
          class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-size-100"
        >
          <credential />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CredentialService } from "../../services/CredentialService.js"
import { TransactionService } from "../../services/TransactionService.js"

import Credential from "./Credential.vue"

import { notify } from "@/mixins/notify.js"
import Box from "@/shared/Box.vue"
import { EventBus } from "@/shared/eventbus.js"

export default {
  name: "Overview",
  mixins: [notify],
  components: { Box, Credential },
  data() {
    return {
      transactionService: new TransactionService(),
      credentialService: new CredentialService(),
      credentials: {
        publicKeySet: false,
        secretKeySet: false,
        encryptionKeySet: false,
        webhookSecretHashSet: false,
      },
      stats: {
        totalTransactions: 0,
        successfulTransactions: 0,
        pendingTransactions: 0,
      },
      loading: false,
    }
  },
  async mounted() {
    await this.loadStats()
    await this.checkCredentialStatus()

    EventBus.$on("credential-updated", this.onCredentialUpdated)
  },

  beforeDestroy() {
    EventBus.$off("credential-updated", this.onCredentialUpdated)
  },
  computed: {
    credentialStatus() {
      // The keys themselves are never returned to the frontend (write-only),
      // so "configured" is judged by the *_set flags, not a stored value.
      if (
        !this.credentials.publicKeySet ||
        !this.credentials.secretKeySet ||
        !this.credentials.encryptionKeySet ||
        !this.credentials.webhookSecretHashSet
      ) {
        return { color: "red", text: "Not Configured" }
      }
      return { color: "green", text: "Configured" }
    },
  },
  methods: {
    async loadStats() {
      try {
        this.loading = true
        const response = await this.transactionService.getTransactions()
        const transactions = response.data.data || []

        this.stats.totalTransactions = transactions.length
        this.stats.successfulTransactions = transactions.filter(
          (t) => t.status === 1,
        ).length
        this.stats.pendingTransactions = transactions.filter(
          (t) => t.status === 0,
        ).length
      } catch (error) {
        console.error("Error loading stats:", error)
        this.alertNotify("error", "Failed to load transaction statistics")
      } finally {
        this.loading = false
      }
    },

    async checkCredentialStatus() {
      try {
        const credential = await this.credentialService.getCredential()
        if (credential) {
          this.credentials = {
            publicKeySet: credential.publicKeySet || false,
            secretKeySet: credential.secretKeySet || false,
            encryptionKeySet: credential.encryptionKeySet || false,
            webhookSecretHashSet: credential.webhookSecretHashSet || false,
          }
        }
      } catch (error) {
        console.error("Error checking credentials:", error)
        this.credentials = {
          publicKeySet: false,
          secretKeySet: false,
          encryptionKeySet: false,
          webhookSecretHashSet: false,
        }
      }
    },

    onCredentialUpdated() {
      this.checkCredentialStatus()
    },
  },
}
</script>

<style scoped lang="scss">
.overview-line {
  margin-top: 1rem;
}
</style>
